import React from "react";
import ContactUs from "./ContactUs";

const Upgrade = () => {
  return <ContactUs />;
};

export default Upgrade;
